'use client'

import { type ReactNode } from 'react'

type Props = {
  serverArticle?: ReactNode
  children: ReactNode
}

/**
 * @function NewsArticleSlot
 * @description статья остаётся в дереве. client-дети — автор и слушатели, не вторая копия текста
 */
const NewsArticleSlot = ({ serverArticle, children }: Props) => (
  <>
    {serverArticle}
    {children}
  </>
)

export default NewsArticleSlot
